module.exports = __webpack_public_path__ + "img/shadow_detective.27ef00e8.png";